// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-8fb21c8b] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
#app-settings[data-v-8fb21c8b] {
  margin-top: auto;
  padding: 3px;
}
#app-settings__header[data-v-8fb21c8b] {
  box-sizing: border-box;
  margin: 0 3px 3px 3px;
}
#app-settings__header .settings-button[data-v-8fb21c8b] {
  padding-inline: 0 calc((var(--default-clickable-area) - 16px) / 2) !important;
}
#app-settings__header .settings-button[data-v-8fb21c8b] .button-vue__text {
  font-weight: normal !important;
}
#app-settings__content[data-v-8fb21c8b] {
  display: block;
  padding: 10px;
  /* prevent scrolled contents from stopping too early */
  margin-bottom: -3px;
  /* restrict height of settings and make scrollable */
  max-height: 300px;
  overflow-y: auto;
  box-sizing: border-box;
}
.slide-up-leave-active[data-v-8fb21c8b],
.slide-up-enter-active[data-v-8fb21c8b] {
  transition-duration: var(--animation-slow);
  transition-property: max-height, padding;
  overflow-y: hidden !important;
}
.slide-up-enter[data-v-8fb21c8b],
.slide-up-leave-to[data-v-8fb21c8b] {
  max-height: 0 !important;
  padding: 0 10px !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppNavigationSettings-2Wh1E3Hq.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,0CAA0C;EAC1C,wCAAwC;EACxC,6BAA6B;AAC/B;AACA;;EAEE,wBAAwB;EACxB,0BAA0B;AAC5B","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-8fb21c8b] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n#app-settings[data-v-8fb21c8b] {\n  margin-top: auto;\n  padding: 3px;\n}\n#app-settings__header[data-v-8fb21c8b] {\n  box-sizing: border-box;\n  margin: 0 3px 3px 3px;\n}\n#app-settings__header .settings-button[data-v-8fb21c8b] {\n  padding-inline: 0 calc((var(--default-clickable-area) - 16px) / 2) !important;\n}\n#app-settings__header .settings-button[data-v-8fb21c8b] .button-vue__text {\n  font-weight: normal !important;\n}\n#app-settings__content[data-v-8fb21c8b] {\n  display: block;\n  padding: 10px;\n  /* prevent scrolled contents from stopping too early */\n  margin-bottom: -3px;\n  /* restrict height of settings and make scrollable */\n  max-height: 300px;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n.slide-up-leave-active[data-v-8fb21c8b],\n.slide-up-enter-active[data-v-8fb21c8b] {\n  transition-duration: var(--animation-slow);\n  transition-property: max-height, padding;\n  overflow-y: hidden !important;\n}\n.slide-up-enter[data-v-8fb21c8b],\n.slide-up-leave-to[data-v-8fb21c8b] {\n  max-height: 0 !important;\n  padding: 0 10px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
